// SPDX-License-Identifier: AGPL-3.0-or-later

interface PositionedEmoji {
	readonly uniqueName?: string;
	readonly name: string;
	readonly id?: string;
	readonly position?: number | null;
}

const EMOJI_NAME_COLLATOR: Intl.CollatorOptions = {numeric: true, sensitivity: 'base'};

function compareEmojiNamesThenIds(a: PositionedEmoji, b: PositionedEmoji): number {
	const left = a.uniqueName || a.name;
	const right = b.uniqueName || b.name;
	const nameOrder = left.localeCompare(right, undefined, EMOJI_NAME_COLLATOR);
	if (nameOrder !== 0) return nameOrder;
	return (a.id ?? '').localeCompare(b.id ?? '');
}

// Explicit `position` sorts ascending and leads; emoji with no position (null/absent) trail and
// fall back to the name/id order. A guild that never reorders anything has every emoji at
// position null, so this must reduce to compareEmojiNamesThenIds exactly in that case — that is
// the entire backward-compatibility story for the ordering feature.
export function compareCustomEmojis(a: PositionedEmoji, b: PositionedEmoji): number {
	const aPosition = a.position ?? null;
	const bPosition = b.position ?? null;
	if (aPosition === null && bPosition === null) {
		return compareEmojiNamesThenIds(a, b);
	}
	if (aPosition === null) return 1;
	if (bPosition === null) return -1;
	if (aPosition !== bPosition) return aPosition - bPosition;
	return compareEmojiNamesThenIds(a, b);
}
